export default __webpack_public_path__ + "static/media/F1_3.142ef361.png";